import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { HardHat, Truck, Package, Building2, CalendarDays } from "lucide-react";
import { eur, fmtDate } from "@/lib/format";

const Section = ({ icon: Icon, title, rows, cols }) => (
  <div>
    <p className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground"><Icon className="h-3.5 w-3.5" /> {title}</p>
    {rows.length === 0 ? (
      <p className="rounded-md bg-secondary/50 px-3 py-2 text-sm text-muted-foreground">Nessuna voce</p>
    ) : (
      <div className="overflow-hidden rounded-md border">
        <table className="w-full text-sm">
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-b last:border-0">
                <td className="px-3 py-1.5 font-medium">{r.nome}</td>
                {cols.map((c, j) => (
                  <td key={j} className="px-3 py-1.5 text-right font-mono text-muted-foreground whitespace-nowrap">{c.render(r)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default function RapportinoView({ open, onOpenChange, rapportino: r }) {
  if (!r) return null;
  const operai = r.operai || [];
  const mezzi = r.mezzi || [];
  const subs = r.subappaltatori || [];
  const t = r.totali || {};

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl max-h-[90vh] overflow-y-auto" data-testid="rapportino-view-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Building2 className="h-5 w-5 text-amber-600" /> {r.cantiere_nome}</DialogTitle>
          <DialogDescription className="flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" /> {fmtDate(r.data)}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-1">
          {r.descrizione_lavori && (
            <div>
              <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Lavori svolti</p>
              <p className="rounded-md bg-secondary/50 px-3 py-2 text-sm">{r.descrizione_lavori}</p>
            </div>
          )}

          <Section icon={HardHat} title="Operai" rows={operai}
            cols={[
              { render: (x) => `${x.ore || 0} h` },
              { render: (x) => eur((x.ore || 0) * (x.paga_oraria || 0)) },
            ]} />
          <Section icon={Truck} title="Mezzi" rows={mezzi}
            cols={[
              { render: (x) => `${x.ore || 0} h` },
              { render: (x) => eur((x.ore || 0) * (x.costo_orario || 0)) },
            ]} />
          <Section icon={Package} title="Subappaltatori" rows={subs}
            cols={[{ render: (x) => eur(x.prezzo || 0) }]} />

          <div className="grid grid-cols-4 gap-2 rounded-lg border bg-secondary/40 p-3 text-center">
            <div><p className="text-[10px] uppercase text-muted-foreground">Manod.</p><p className="font-mono text-sm font-semibold">{eur(t.costo_manodopera)}</p></div>
            <div><p className="text-[10px] uppercase text-muted-foreground">Mezzi</p><p className="font-mono text-sm font-semibold">{eur(t.costo_mezzi)}</p></div>
            <div><p className="text-[10px] uppercase text-muted-foreground">Subapp.</p><p className="font-mono text-sm font-semibold">{eur(t.costo_subappalti)}</p></div>
            <div><p className="text-[10px] uppercase text-muted-foreground">Totale</p><p className="font-mono text-sm font-bold text-amber-600">{eur(t.costo_totale)}</p></div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
